module.exports = __webpack_public_path__ + "img/icon-voice-assistant-select.d53448c7.svg";